const getNumberValue = (item, keys, fallback = Number.MAX_SAFE_INTEGER) => {
  for (const key of keys) {
    const value = item?.[key];
    if (typeof value === "number" && Number.isFinite(value)) {
      return value;
    }

    if (typeof value === "string" && value.trim() !== "") {
      const parsed = Number(value);
      if (Number.isFinite(parsed)) {
        return parsed;
      }
    }
  }

  return fallback;
};

const getTimeValue = (item, keys, fallback = Number.MAX_SAFE_INTEGER) => {
  for (const key of keys) {
    const value = item?.[key];
    if (!value) {
      continue;
    }

    const timeValue = new Date(value).getTime();
    if (Number.isFinite(timeValue)) {
      return timeValue;
    }
  }

  return fallback;
};

const getStringValue = (item, keys) => {
  for (const key of keys) {
    const value = item?.[key];
    if (typeof value === "string" && value.trim() !== "") {
      return value.trim();
    }
  }

  return "";
};

export const orderSubRights = (subRights = []) => {
  if (!Array.isArray(subRights)) {
    return [];
  }

  return [...subRights].sort((a, b) => {
    const orderA = getNumberValue(a, [
      "sortOrder",
      "displayOrder",
      "order",
      "position",
      "sequence",
    ]);
    const orderB = getNumberValue(b, [
      "sortOrder",
      "displayOrder",
      "order",
      "position",
      "sequence",
    ]);

    if (orderA !== orderB) {
      return orderA - orderB;
    }

    const createdA = getTimeValue(a, [
      "createdDate",
      "createdAt",
      "dateAdded",
      "updatedDate",
    ]);
    const createdB = getTimeValue(b, [
      "createdDate",
      "createdAt",
      "dateAdded",
      "updatedDate",
    ]);

    if (createdA !== createdB) {
      return createdA - createdB;
    }

    const idA = getNumberValue(a, ["id", "subRightId"]);
    const idB = getNumberValue(b, ["id", "subRightId"]);
    if (idA !== idB) {
      return idA - idB;
    }

    const titleA = getStringValue(a, ["title", "subRightTitle", "name", "subRightName"]);
    const titleB = getStringValue(b, ["title", "subRightTitle", "name", "subRightName"]);
    return titleA.localeCompare(titleB, undefined, { sensitivity: "base" });
  });
};
